import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../../utils/ResponseConver";
import Framo from "../../../../../company/pages/ship/child/CargoMachineryFields/Framo";
import { FramoLog } from "../../components/CargoMachinCom/Framo";

export const FramoList = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [FRAMO_Data, set_FRAMO_Data] = useState([]);

  const GET_SHIP_FRAMO_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);

      post(ApiURL.list_cargo_machinery_framo_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const updatedData = res.framo_parameters_data.map((item) => ({
            ...item,
          }));
  
          const updatedDataWithFormattedParams = updatedData.map((item) => ({
            ...item,
            selected_parameters: updateSelectedParameters(item?.selected_parameters),
          }));

          set_loader(false);
          set_FRAMO_Data(updatedDataWithFormattedParams);
        }
      });

      set_loader(false);
    } catch (error) {
      set_loader(false);
      console.error("Error BWT list:", error);
    }
  };



  useEffect(() => {
    GET_SHIP_FRAMO_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FRAMO_Data && FRAMO_Data?.length > 0 ? (
              <>
                {FRAMO_Data?.map((_items) => (
                  <FramoLog
                    key={_items.id} // add key for performance
                    eng_log_basic_id={eng_log_basic_id}
                    _items={_items}
                  />
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
